<template>
    <vx-expandable-card>
        <template v-slot:content>
            <h3 class="text-xl text-slate-700 font-extrabold">{{ file ? 'Upload Preview' : 'Upload' }}</h3>
            <p class="text-sm" data-test="upload-summary-text">
                <template v-if="file">
                    Last chance to confirm everything looks good before we run the import.
                </template>
                <template v-else>
                    New contacts will be created. Phone numbers that match an existing contact will be updated with what
                    you upload. Any conflicts with the subscription status or tags set above will be overridden by the
                    CSV values.
                </template>
            </p>

            <drag-and-drop-file
                v-model="file"
                :icon="faFileCsv"
                :validate="validateCsvFile"
                @selected="emit('selected', $event)"
                class="my-4"
            ></drag-and-drop-file>

            <vx-alert v-if="!file" color="info" :closeable="false">
                Files must be <strong>CSV</strong> and less than <strong>1GB</strong>.
            </vx-alert>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { faFileCsv } from '@fortawesome/pro-solid-svg-icons';
import { VxAlert, VxExpandableCard } from '@voxie/frontend-components';
import DragAndDropFile from '~/components/general/DragAndDropFile.vue';
import { validateCsvFile } from './validateCsvFile';
import { ref } from 'vue';

const emit = defineEmits(['selected']);
const file = ref();
</script>
